import React from "react";
import List from "features/Accountant/CodManagement/List/List";

const CodManagementList = () => {
  return <List />;
};

export default CodManagementList;
